/**
 * One entrance ticket (EventTicket) of an event in the Tickets tab.
 */
class EventTicketCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    private contactLabel:MUILabel = null;
    private codeLabel:MUILabel = null;
    private priceLabel:MUILabel = null;
    private dateLabel:MUILabel = null;
    private statusLabel:MUILabel = null;

    private cf:MIONumberFormatter = MUIWebApplication.sharedInstance().delegate.currencyFormatter;
    private dtf:MIODateFormatter = MUIWebApplication.sharedInstance().delegate.dateTimeFormatter;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, 'name-lbl', 'MUILabel');
        this.contactLabel = MUIOutlet(this, 'contact-lbl', 'MUILabel');
        this.codeLabel = MUIOutlet(this, 'code-lbl', 'MUILabel');
        this.priceLabel = MUIOutlet(this, 'price-lbl', 'MUILabel');
        this.dateLabel = MUIOutlet(this, 'date-lbl', 'MUILabel');
        this.statusLabel = MUIOutlet(this, 'status-lbl', 'MUILabel');
    }

    set item(t:EventTicket){
        this.nameLabel.text = t.name;
        this.contactLabel.text = [t.email, t.phone].filter(x => x != null && x.length > 0).join(" · ");
        this.codeLabel.text = t.code;
        this.priceLabel.text = this.cf.stringFromNumber(t.price || 0);
        this.dateLabel.text = t.beginDate != null ? this.dtf.stringFromDate(t.beginDate) : "";
        this.statusLabel.text = t.consumptionDate != null ? MIOLocalizeString("CHECKED_IN", "Checked in") : MIOLocalizeString("ISSUED", "Issued");
    }
}
